const PLAN_URL = "https://preview.insightwin.com/backend/plan";
// const PLAN_URL = "http://localhost:7100/backend/plan";

export default PLAN_URL;
